import { RouterProps, withRouter } from 'react-router';
import * as React from 'react';
import Footer from '../App/components/Layout/Footer/Footer';
import Header from '../App/components/Layout/Header/Header';
import MainNavigation from '../App/components/Layout/MainNavigation/MainNavigation';
import withRouteMetadata from '../App/hocs/withRouteMetadata';
import { IRouteMetadataType } from '../App/modules/Base/types/IRouteMetadataType';
import LeafletsInState from '../App/modules/Leaflet/components/LeafletsInState/LeafletsInState';
import { currentEntryWord, pluralizerLeaflets } from '../App/utils/routeMetadataUtils';
import { withClickbait, withTitlePostfix } from '../App/utils/routeMetadataUtils';
import BaseRoute from './_BaseRoute';
import FlexWrapper from '../App/components/Layout/Flexbox/FlexWrapper';
import AdItem from '../App/components/General/AdItem/AdItem';
import AdConfig from '../App/components/General/AdConfig/AdConfig';


class LeafletsInStateRoute extends BaseRoute {
	public static async getInitialProps(state: any) {
		const reduxData = await LeafletsInStateRouteProps(state);

		return { reduxData };
	}

	public render() {
		const query = (this.props.match.params) ? this.props.match.params : {};

		return (
			<React.Fragment>

				<AdConfig
					desktopIds={[4403488]}
					mobileIds={[4403478, 4403477]}
					superbannerId={4403489}
					sitebarId={4403487}
				/>

				<Header />

				<MainNavigation />

				<FlexWrapper>
					<div>
						<LeafletsInState
							stateSlug={query.state + ''}
							{...this.props}
						/>

						<Footer />
					</div>

					<AdItem
						desktopAdId={4403487}
						maxHeight={600}
						maxWidth={300}
						type="side"
						className="startBelowMenuBar"
					/>
				</FlexWrapper>

			</React.Fragment>
		);
	}
}

export default withRouter(
	withRouteMetadata(
		LeafletsInStateRoute,
		(props: any) => `lst-${props.match.params.state}`,
		{
			pageTitle: (routeMetadata: IRouteMetadataType) => `${routeMetadata.totalItemsCount || ''} ${currentEntryWord(routeMetadata.totalItemsCount)} ${pluralizerLeaflets(routeMetadata.totalItemsCount)} im Bundesland ${routeMetadata.state.title}`,
			metaTitle: (routeMetadata: IRouteMetadataType) => withTitlePostfix(`${routeMetadata.totalItemsCount || ''} ${currentEntryWord(routeMetadata.totalItemsCount)} ${pluralizerLeaflets(routeMetadata.totalItemsCount, true)} » ${routeMetadata.state.title}`),
			metaDescription: (routeMetadata: IRouteMetadataType) => withClickbait(`Alle ${routeMetadata.totalItemsCount || ''} ${pluralizerLeaflets(routeMetadata.totalItemsCount, true)} im Überblick » bei Aktionsfinder informieren ✓ alle Schnäppchen finden ✓ Preise vergleichen ✓`, `Jetzt entdecken!`),
		} as IRouteMetadataSetterType
	)
);
